(ns ui.subscription.part
  "Useful subscription related functions to work with world
   approach on the client-side"
  (:require [parts.replicant.query :as query]
            [app.subscription.suggest-upgrade :as suggest-upgrade]))

(def subscription-query
  {:query/kind :query/subscription})

(def instagram-accounts-query
  {:query/kind :query/ig-accounts})

(defn get-billing-interval
  [state]
  (or (:billing-interval state)
      :month))

(defn get-services
  [w]
  (into {}
        (map
          (fn [service]
            [(:id service)
             (merge service
                    {:days (case (get-billing-interval w)
                             :year
                             365
                             :month
                             31)})]))
        (:services (query/get-result w
                                     subscription-query))))

(defn calc-service-total
  [{:keys [service] :as state}]
  (* (if (= (:billing-unit service)
            :day)
       (:days service)
       1)
     (or (get-in state
                 [:receipt
                  :quantity
                  (:id service)])
         (:default-units service))
     (:price service)))

(defn get-discounts
  "Returns the discounts map from the subscription query result."
  [w]
  (:discounts (query/get-result w subscription-query)))

(defn get-service-discount
  "Returns the discount for a specific service, if any."
  [w service-id]
  (get (get-discounts w) service-id))

(defn calc-discount-amount
  "Calculates the discount amount for a service.
   Returns 0 if no discount applies."
  [{:keys [service] :as state}]
  (let [discount (get-service-discount state (:id service))]
    (if discount
      (let [original-total (calc-service-total state)]
        (* original-total discount))
      0)))

(defn calc-service-total-with-discount
  "Calculates the service total after applying discount.
   Returns original total if no discount applies."
  [{:keys [service] :as state}]
  (let [original-total (calc-service-total state)
        discount-amount (calc-discount-amount state)]
    (- original-total discount-amount)))

(defn calc-total-savings
  "Calculates total savings across all services in the receipt."
  [w]
  (apply +
         (map
           (fn [service-id]
             (calc-discount-amount (assoc w
                                          :service
                                          (service-id (:services w)))))
           (:service-order w))))

(defn calc-receipt-total
  "Calculates the total receipt amount with discounts applied."
  [w]
  (apply +
         (map
           (fn [service-id]
             (calc-service-total-with-discount (assoc w
                                                      :service
                                                      (service-id (:services w)))))
           (:service-order w))))

(defn add-subscription-item
  [w]
  (let [subscription (query/get-result w
                                       subscription-query)]
    (assoc w
           :subscription-item
           (-> subscription
               :organization/paddle-subscription
               :items
               (first)))))

(defn add-services
  [w]
  (assoc w
         :services
         (get-services w)))

(defn add-instagram-accounts
  [w]
  (assoc w
         :instagram-accounts (:instagram-accounts (query/get-result w
                                                                    instagram-accounts-query))))

(defn update-instagram-seats
  [w]
  (-> w
      (update-in [:services :instagram-connection]
                 (fn [service]
                   (assoc service
                          :marked true
                          :default-units (count (:instagram-accounts w))
                          :units-min (count (:instagram-accounts w)))))))

(defn add-receipt-total
  [w]
  (assoc w
         :receipt-total (calc-receipt-total w)))

(defn add-total-savings
  [w]
  (assoc w
         :total-savings (calc-total-savings w)))

(defn add-service-order
  [w]
  (assoc w
         :service-order [:instagram-connection
                         :ai-image
                         :tiktok-post
                         :youtube-short
                         :social-post
                         :x-post
                         :x-post-link
                         :storage-flat-fee]))

(defn add-prices
  [w]
  (let [subscription (query/get-result w
                                       subscription-query)]
    (assoc w
           :prices
           (:subscription/prices subscription))))

(defn suggest-upgrade
  "Calculates if a selected plan of `quantity` and `billing-interval` is sufficient
   to run `instagram-account-count` of connections, taking price-adjustments
   into account."
  [{:keys [billing-interval quantity instagram-account-count]
    :as w}]
  (suggest-upgrade/suggest-upgrade
    {:billing-interval billing-interval
     :quantity quantity
     :instagram-connections-count instagram-account-count
     :services (get-services w)
     :discounts (get-discounts w)}))
